import { FC, useId } from 'react';
import classNames from 'classnames';
import { RecipientStatus, RestrictedRecipientStatus } from 'store/recipients/types';

const BANNER_TEXT: Record<RestrictedRecipientStatus, string> = {
  [RecipientStatus.LOST]: 'This candidate lost',
  [RecipientStatus.WITHDREW]: 'This candidate withdrew',
  [RecipientStatus.IN_SESSION_RESTRICTED]: 'This candidate is in session',
};

const STATUS_CLASS: Record<RestrictedRecipientStatus, string> = {
  [RecipientStatus.LOST]: 'lost',
  [RecipientStatus.WITHDREW]: 'withdrew',
  [RecipientStatus.IN_SESSION_RESTRICTED]: 'in-session-restricted',
};

interface Props {
  recipientStatus: RestrictedRecipientStatus;
}

export const RestrictedCandidateBanner: FC<Props> = ({ recipientStatus }) => {
  const bannerId = useId();
  const barText = BANNER_TEXT[recipientStatus];
  const statusClass = STATUS_CLASS[recipientStatus];

  return (
    <div
      className={classNames('restricted-candidate-bar', statusClass)}
      tabIndex={0}
      aria-describedby={bannerId}
    >
      <div className="candidate-detail-banner" role="tooltip" id={bannerId}>
        <p className="banner-text">
          {barText} and is not eligible to receive donations, so they can't be added to the cart.
        </p>
      </div>
      <span className="candidate-detail-bar-text">{barText}</span>
    </div>
  );
};
